// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"fc3fdf60","977":"6271b440"}[chunkId] + ".chunk.js";
};